export const preloadImage = (
  logoUrl: string,
  onLoad?: () => void,
  onError?: () => void,
) => {
  if (!logoUrl || logoUrl === "") {
    return;
  }

  const img = new Image();
  img.onload = () => onLoad?.();
  img.onerror = () => onError?.();
  img.src = logoUrl;
};
